
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/[slug]/[destinationSlug]",
      function () {
        return require("private-next-pages/destinations/[slug]/[destinationSlug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/[slug]/[destinationSlug]"])
      });
    }
  